import React from 'react';
import { styled } from '@mui/material';
import { RLabel } from './RLabel';

interface RFieldGroupProps {
    label: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
}

export function RFieldGroup({ label, children, style }: RFieldGroupProps) {
    return (
        <Group style={style}>
            <RLabel>{label}</RLabel>
            {children}
        </Group>
    );
}

const Group = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
});
